export default __webpack_public_path__ + "static/media/yosemite.2bee8433.jpg";